import React from 'react';
export const ReviewSection = () => {
  return <section className="py-4" data-id="element-123">
      <div className="mb-6" data-id="element-124">
        <h2 className="text-[24px] font-bold mb-4" data-id="element-125">
          I tested Petssey DNRx myself, and here's what I found:
        </h2>
        <div className="bg-gray-50 p-4 rounded-lg mb-4" data-id="element-126">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/f4Sk3q9vJ6z6Ganhv1uciB/ChatGPT_Image_Aug_26%2C_2025%2C_06_49_41_PM.png" alt="Hand holding Petssey DNRx device next to a beige couch with wooden bookshelf in the background" className="w-full h-auto object-cover rounded mb-4" data-id="element-127" />
          <h3 className="font-semibold mb-2 text-[20px]" data-id="element-128">Week 1</h3>
          <p className="text-[18px] text-[#323232] mb-4" data-id="element-129">
            When my Petssey DNRx arrived, I knew I had the perfect weapon
            against the lingering cat dander allergens in my home. It's
            completely plug-and-play, so it began working immediately, with a
            subtle indicator light as the only sign of the hard work it was
            doing. I placed one in my lounge room, another in my bedroom—and the
            relief from cat dander was almost instant.
          </p>
          <p className="text-[18px] text-[#323232] mb-4" data-id="element-130">
            Sure, I had my doubts, thinking, "Can this compact device really
            eliminate stubborn airborne allergens like cat dander?" But the
            first breath of truly clean, fresh air was enough to erase all
            doubts. The difference wasn't just noticeable—it was life-changing.
          </p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg mb-4" data-id="element-131">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x1VdDPehfUAVqHgtydSfRw/ChatGPT_Image_Aug_26%2C_2025%2C_10_32_41_PM.png" alt="Woman whisking in a kitchen bowl with Petssey DNRx device mounted on the wall" className="w-full h-auto object-cover rounded mb-4" data-id="element-132" />
          <h3 className="font-semibold mb-2 text-[20px]" data-id="element-133">Week 2</h3>
          <p className="text-[18px] text-[#323232] mb-4" data-id="element-134">
            After a week, my home felt transformed. Even the hidden corners
            seemed to be free of cat dander particles. The air quality? Far
            better than it had ever been. The promise of negative ion technology
            effectively eliminating cat allergens wasn't just marketing hype—it
            was reality. Only a few days in and my home felt like a dander-free
            sanctuary.
          </p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg mb-4" data-id="element-135">
          <img src="https://media.giphy.com/media/Rm3P9cWG2cbDCpabV1/giphy.gif" alt="Man in blue shirt entering a room with Petssey DNRx device mounted on the wall" className="w-full h-auto object-cover rounded mb-4" data-id="element-136" />
          <h3 className="font-semibold mb-2 text-[20px]" data-id="element-137">Week 3</h3>
          <p className="text-[18px] text-[#323232] mb-4" data-id="element-138">
            Here's something you'll love—walking into your home and breathing
            freshness you'd only associate with mountain air or ocean breezes.
            And when friends and family notice it, prepare to accept compliments
            for your immaculately fresh-smelling, allergen-free home. My secret?
            The Petssey DNRx—the unsung hero of my home.
          </p>
        </div>
        <p className=" text-center text-[12px] italic text-[#6f6f6f] mb-4" data-id="element-139">
          * The above text are based on real Petssey DNRx customer experiences,
          your results may vary.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-140">
          The true beauty of Petssey DNRx lies in its simplicity. No complicated
          setup, no filters to replace, and no loud noises. Just plug it in and
          feel the difference it makes in your life and the lives of your furry
          companions.
        </p>
      </div>
      <div className="mb-6" data-id="element-141">
        <h2 className="text-[26px] font-bold mb-4" data-id="element-142">MY FINAL THOUGHTS</h2>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-143">
          If you're tired of persistent cat dander allergies in your home and
          want to breathe easier, switching to Petssey DNRx will save you time
          and money in the long run.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-144">
          Traditional air purifiers and professional cleaning services can be
          expensive, with some costing up to a whopping $2,000. Plus, they
          require time-consuming maintenance and their filter replacements are
          always so expensive and complicated...
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-145">
          The Petssey DNRx is more affordable, less bulky, and quieter than
          regular air purifiers. That's why devices like the DNRx, using
          negative ion technology, are one of the fastest-growing trends among
          Australian cat parents.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-146">
          I've used Petssey DNRx for more than a month and can confirm that it
          effectively eliminates cat dander and other allergens, offering a
          unique solution no other device can match.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-147">
          Most importantly, it means you no longer have to choose between your
          beloved cat and a healthy, dander-free home. With the Petssey DNRx,
          you can have both!
        </p>
      </div>
      <div className="mb-2" data-id="element-148">
        <h2 className="text-[26px] font-bold mb-4" data-id="element-149">
          How much does it cost? Is it worth it?
        </h2>
        <a href="https://petssey.com/products/petssey-dnrx" data-id="element-150">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9eiCL297M3SwZps1PmiDME/ChatGPT_Image_Sep_1%2C_2025%2C_02_46_00_PM.png" alt="Collage of Petssey DNRx devices installed in different areas of a home - bedroom, bathroom, living room, and near a cat litter box" className="w-full h-auto object-cover rounded mb-4" data-id="element-151" />
        </a>
        <p className="text-[22px] text-[#323232] mb-6" data-id="element-152">
          Petssey DNRx is regularly priced at $79.00 per device—which makes
          sense for such advanced negative ion technology. But if you're like
          Margaret and want one in every room where your cat spends time, the
          cost can add up pretty quickly. Luckily, Petssey is running a
          limited-time bundle and save deal, where you can get the DNRx for as
          low as <span className="text-red-500 line-through" data-id="element-153">$79.99</span>{' '}
          <span className="font-bold" data-id="element-154">$21.99</span> per device when you stock up
          <br data-id="element-155" />
          <a href="https://petssey.com/products/petssey-dnrx" data-id="element-156">
          <span className="text-[18px] bg-[#fef850] text-blue-600 inline-block mt-2" data-id="element-157">
            — that's up to 72% off the retail price. -
          </span>
          </a>
        </p>
        <p className="font-bold italic text-[18px] text-[#323232] mb-6" data-id="element-158">
          *Petssey DNRx is offering a unique bundle discount to try their
          best-selling, cat dander allergen air-purifying device starting on the
          9th September 2025.
        </p>
        <p className="text-[22px] text-[#323232] mb-0" data-id="element-159">
          As someone who has reviewed hundreds of innovative home gadgets, I can
          honestly say I've never encountered a product that offers such
          significant value for such an affordable price. I highly recommend the
          Petssey DNRx to anyone who wants to protect their home from harmful
          airborne allergens like cat dander and enjoy fresher, cleaner air
          every day.
        </p>
      </div>
    </section>;
};